import React from "react";
import { node, string } from "prop-types";
import { classes } from "../utils/classes";
import { Col, Row } from "../Grid";
import Link from "../Link";

const FooterCopyright = ({ className = "", children }) => (
	<div className={classes("footer__copyright", className)}>
		<Row mx py sx={{ textAlign: "center", lg: { textAlign: "right" } }}>
			{children}
		</Row>
	</div>
);

FooterCopyright.propTypes = {
	className: string,
	children: node.isRequired,
};

export const FooterCopyrightText = ({ children }) => (
	<Col spacing={{ pt: 0 }}>
		<div className="footer__copyright_text">{children}</div>
	</Col>
);

FooterCopyrightText.propTypes = {
	children: node.isRequired,
};

export const FooterCopyrightLink = ({ href, className = "", children, ...props }) => {
	return (
		<Link
			isBaseClassName={false}
			className={classes("footer__copyright_link", className)}
			href={href}
			{...props}
		>
			{children}
		</Link>
	);
};

FooterCopyrightLink.propTypes = {
	href: string.isRequired,
	className: string,
	children: node.isRequired,
};

const CompanyName = ({ children }) => {
	return <span className="footer__copyright_company">{children}</span>;
};

CompanyName.propTypes = {
	children: node.isRequired,
};

FooterCopyrightText.CompanyName = CompanyName;

export default FooterCopyright;
